"use client"

import React from 'react'
import { motion } from 'framer-motion'
import { Clock, RefreshCw, Sparkles } from 'lucide-react'
import { CardContent, CardFooter, CardHeader, CardTitle, CardV2 } from '../CardV2/CardV2'
import { ButtonV2 } from '../ButtonV2/ButtonV2'
import { useTranslation } from 'react-i18next'

export interface BookingSlotUnavailableProps {
  onRetry: () => void
}

export const BookingSlotUnavailable: React.FC<BookingSlotUnavailableProps> = ({ onRetry }) => {
  const { t } = useTranslation();

  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
      className="w-full px-2 sm:px-0"
    >
      <CardV2 className="w-full">
        <CardHeader className="text-center px-4 sm:px-6">
          <div className="flex flex-col items-center space-y-4">
            <div className="relative">
              <Clock className="h-12 w-12 text-amber-500" />
              <Sparkles className="h-5 w-5 text-amber-400 absolute -top-1 -right-1 animate-pulse" />
            </div>
            <CardTitle className="text-xl sm:text-2xl text-amber-700">
              {t('booking.slot_unavailable.title', 'Oops! Someone was faster! ⚡')}
            </CardTitle>
            <p className="text-muted-foreground text-sm sm:text-base px-2 max-w-md">
              {t('booking.slot_unavailable.message', 'Another bride just snagged this time slot! But don\'t worry, there are plenty of other amazing times available. Let\'s find you the perfect slot! ✨')}
            </p>
          </div>
        </CardHeader>
        <CardContent className="space-y-6 pt-6 px-4 sm:px-6">
          <div className="bg-amber-50 border border-amber-200 rounded-lg p-4 sm:p-6 space-y-4">
            <h3 className="font-semibold text-lg text-amber-900">
              {t("booking.slot_unavailable.encouragement", "Ready to try again? 💪")}
            </h3>
            <p className="text-sm sm:text-base text-amber-800">
              {t("booking.slot_unavailable.instructions", "Just click the button below to refresh and see all available time slots. We're sure you'll find the perfect time for your special day!")}
            </p>
          </div>
        </CardContent>
        <CardFooter className="flex flex-col sm:flex-row justify-center gap-3 sm:gap-4 px-4 sm:px-6 pb-4 sm:pb-6">
          <ButtonV2 onClick={onRetry} className="w-full sm:w-auto bg-amber-500 hover:bg-amber-600 text-white">
            <RefreshCw className="mr-2 h-4 w-4" />
            {t("booking.slot_unavailable.try_again", "Find Another Time Slot")}
          </ButtonV2>
        </CardFooter>
      </CardV2>
    </motion.div>
  )
}

